import { useEffect, useState } from 'react'
import { CookieCategory } from './CookieCategory'
import { hasConsentForCategory } from './consentManager'

export const useOneTrustConsentCategory = (
  category: CookieCategory,
): boolean => {
  const [hasConsented, setHasConsented] = useState(false)

  useEffect(() => {
    if (hasConsentForCategory(category, true)) setHasConsented(true)

    const handler = (event: Event) => {
      const customEvent = event as CustomEvent<string[]>
      if (customEvent.detail?.includes(category)) setHasConsented(true)
    }

    window.addEventListener('OneTrustGroupsUpdated', handler)
    return () => {
      window.removeEventListener('OneTrustGroupsUpdated', handler)
    }
  }, [category])

  return hasConsented
}
